<template>
  <div class="container-wrapper">
    <div class="full-width">
      <ladderTracker />
    </div>
  </div>
</template>

<script>
import ladderTracker from '@/components/ladderTracker.vue';

export default {
  name: 'ladderView',
  components: { ladderTracker },
};
</script>
